import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import classNames from 'classnames'
import { UserSessionActionCreators } from 'app/reducers/UserSessionRedux'
import useUserSessionLogger, {
  USER_SESSION_ACTION_TYPES,
} from 'components/UserSession/useUserSessionLogger'

import Switch from 'controls/Switch'
import { Button, IonIcon } from 'controls'
import GeneralFeedback from 'components/Feedback'
import {
  DeviceHeader,
  DeviceFooter,
} from 'components/Forms/UserSessionForm/Commons'

import { logoutSessionsStyles, sessionStyles } from './styles'

function Session({ alias, deviceInfo, id, lastLoggedAt, onSwitch, checked }) {
  return (
    <section className={classNames("session", { 'in-active': !checked })}>
      <Switch checked={checked} onChange={checked => onSwitch(checked, id)} />
      <div className="session-details">
        <p className="session-alias">
          <strong> {alias} </strong>
          <small className="last-login">
            <strong>
              <span>Último login {moment(lastLoggedAt).fromNow()}</span>
            </strong>
            <IonIcon size="small" icon="md-time" />
          </small>
        </p>
        <p className="session-info">
          <small>{deviceInfo}</small>
        </p>
      </div>
      <style jsx>{sessionStyles}</style>
    </section>
  )
}

const howManyDevicesShouldBeLogout = ({
  activeSessions,
  logoutDevices,
  limitUserActiveSessions,
}) => {
  const currrentSession = 1
  return (
    activeSessions + currrentSession - logoutDevices - limitUserActiveSessions
  )
}

function LogoutSessions() {
  useUserSessionLogger(USER_SESSION_ACTION_TYPES.EXCEEDED_SESSIONS)

  const dispatch = useDispatch()
  const [logoutDevices, setLogoutDevices] = useState([])
  const {
    activeSessions,
    getSessionsFeedback,
    logoutSessionsFeedback,
    limitUserActiveSessions,
  } = useSelector(state => state.userSession)

  useEffect(() => {
    dispatch(UserSessionActionCreators.getSessionsRequest())
  }, [])

  function hadleLogoutDevices(logoutDevices) {
    dispatch(UserSessionActionCreators.logoutSessionsRequest(logoutDevices))
  }

  if (!getSessionsFeedback.success) {
    return <GeneralFeedback {...getSessionsFeedback} />
  }

  function handleSwitch(checked, deviceId) {
    if (checked) {
      setLogoutDevices(devices => devices.filter(device => device !== deviceId))
    } else {
      setLogoutDevices(devices => [...devices, deviceId])
    }
  }

  const devicesToLogout = howManyDevicesShouldBeLogout({
    activeSessions: activeSessions.length,
    logoutDevices: logoutDevices.length,
    limitUserActiveSessions: limitUserActiveSessions,
  })

  return (
    <article
      data-qa="user-session-logout-container"
      className="user-session-logout-container"
    >
      <DeviceHeader title="Sesiones activas" />

      <div className="user-session-logout-container-body">
        {activeSessions.map(session => (
          <Session
            key={session.id}
            {...session}
            checked={!logoutDevices.includes(session.id)}
            onSwitch={handleSwitch}
          />
        ))}

        {devicesToLogout > 0 && (
          <p className="session-logout-warning">
            <IonIcon icon="md-warning" />
            Necesita desloguear al menos {devicesToLogout}{' '}
            {devicesToLogout === 1 ? 'sesión' : 'sesiones'} más.
          </p>
        )}

        <div className="logout-button-container form-input-margin">
          <Button
            onClick={() => hadleLogoutDevices(logoutDevices)}
            loading={logoutSessionsFeedback.loading}
            disabled={devicesToLogout > 0}
            size="large"
            className="logout-button"
            color={devicesToLogout > 0 ? 'tertiary' : 'primary'}
          >
            Continuar
          </Button>
        </div>
      </div>

      <DeviceFooter />

      <style jsx>{logoutSessionsStyles}</style>
    </article>
  )
}

export default LogoutSessions
